import { createSlice } from "@reduxjs/toolkit";

export interface IChatState {
  isLoading: boolean;
  error: string;
  success: string;
  messageText: string;
  messageTab: number;
  selectedChatIndex: number;
  openProjectMediaTray: boolean;
  chatRegisteredDetails: any;
  chatUsersList: any;
  searchKey: any;
  selectedUserChatList: any;
  chatType: string;
  registeredUsersList: any;
  collaboratorsInProject: any;
  groupParticipants: any;
  isCollaboratorsFetchedSuccessfully: boolean;
  projectGroupDetails: any;
  groupByProjectDetails: any;
  unreadMessages: boolean;
}

const initialState: IChatState = {
  isLoading: false,
  error: "",
  success: "",
  messageText: "",
  messageTab: 0,
  selectedChatIndex: 0,
  openProjectMediaTray: false,
  chatRegisteredDetails: null,
  chatUsersList: [],
  searchKey: "",
  selectedUserChatList: [],
  chatType: "chat",
  registeredUsersList: [],
  collaboratorsInProject: [],
  groupParticipants: [],
  isCollaboratorsFetchedSuccessfully: false,
  projectGroupDetails: null,
  groupByProjectDetails: null,
  unreadMessages: false
};

export const chatRedux: any = createSlice({
  name: "chatRedux",
  initialState,
  reducers: {
    setChatState: (state: any, action: any) => {
      const newState = {
        ...state,
        [action.payload.key]: action.payload.value,
      };
      return newState;
    },
    getAllCollaboratorByProjectIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isCollaboratorsFetchedSuccessfully: false,
      };
      return newState;
    },
    getAllCollaboratorByProjectIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        collaboratorsInProject: action?.payload?.data,
        isLoading: false,
        isCollaboratorsFetchedSuccessfully: true,
      };
      return newState;
    },
    getAllCollaboratorByProjectIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorsFetchedSuccessfully: false,
      };
      return newState;
    },

    // create project chat group
    createProjectGroupRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        success: false
      };
      return newState;
    },
    createProjectGroupSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        success: true,
      };
      return newState;
    },
    createProjectGroupFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        success: false
      };
      return newState;
    },

    // create project chat group
    getProjectGroupDataRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        success: false,
        groupByProjectDetails: null
      };
      return newState;
    },
    getProjectGroupDataSuccess: (state: any, action: any) => {
      const response = action?.payload?.data;
      console.log(response, "line120")
      const newState = {
        ...state,
        isLoading: false,
        success: true,
        groupByProjectDetails: response
      };
      return newState;
    },
    getProjectGroupDataFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        success: false,
        groupByProjectDetails: null
      };
      return newState;
    },
  },
});

export const {
  setChatState,

  getAllCollaboratorByProjectIdRequest,
  getAllCollaboratorByProjectIdSuccess,
  getAllCollaboratorByProjectIdFailure,

  createProjectGroupRequest,
  createProjectGroupSuccess,
  createProjectGroupFailure,

  getProjectGroupDataRequest,
  getProjectGroupDataSuccess,
  getProjectGroupDataFailure

} = chatRedux.actions;

export default chatRedux.reducer;
